"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _window, _window2;
// prevent ie11 from grey screening
if (typeof window !== 'undefined' && (!((_window = window) !== null && _window !== void 0 && _window.console) || (0, _keys.default)((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.console).length === 0)) {
  window.console = {
    log: function log() {},
    info: function info() {},
    error: function error() {},
    warn: function warn() {}
  };
}
var _default = exports.default = {
  log: function log() {
    if (process.env.NODE_ENV !== 'production') {
      console.log.apply(this, arguments); // eslint-disable-line
    }
  },
  info: function info() {
    if (process.env.NODE_ENV !== 'production') {
      console.info.apply(this, arguments); // eslint-disable-line
    }
  },
  warn: function warn() {
    if (process.env.NODE_ENV !== 'production') {
      console.warn.apply(this, arguments); // eslint-disable-line
    }
  },
  error: function error() {
    console.error.apply(this, arguments); // eslint-disable-line
  }
};